/**
 * "1 PubMed result", "205 PubMed results". The number is the hit count of the compound's stored PubMed query,
 * so the label says results, never studies.
 */
export function pubmedResultsLabel(count: number): string {
  return `${count.toLocaleString("en-US")} PubMed result${count === 1 ? "" : "s"}`;
}
